// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment, ReactNode } from 'react';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Form } from 'react-bootstrap';
import PhotoWidget from '../utils/FormWidgets/PhotoWidget';
import FileUploader from '../utils/FormWidgets/FileUploader';
import Succsess from '../stateMessage/Succsess';
import TopPanel from '../utils/TopPanel';
import { getActivityPhoto } from '../activities/utils';
import DragnDropTable from '../utils/DragnDrop/DragnDropTable';
import ElementSelector from '../utils/FormWidgets/ElementSelector';
import {
  getBase64,
  isMobileResolution,
} from '../../infrastructure/utils/common';
import RouterLeavingGuard from '../routing/RouteLeavingGuard';
import DragnDropGrid from '../utils/DragnDrop/DragnDropGrid';
import Spinner from '../utils/Spinner';
import GeneraPanel from '../cityGuides/general/GeneralForm';
import Modal from '../utils/ModalComponet';
import CheatsheetForm from '../cityGuides/cheatsheets/CheatcheetForm';
import EntertainmentElement from '../cityGuides/entertainments/EntertainmentElem';
import CheatsheetElement from '../cityGuides/cheatsheets/CheatcheetElement';
import CityHappeningForm from '../cityGuides/cityHappenings/CityHappeningsForm';
import CityHappeningsElement from '../cityGuides/cityHappenings/CityHappeningsElement';
import PlacesElement from '../cityGuides/places/PlacesElement';
import PhotoElem from '../cityGuides/photos/PhotoElem';
import ExperienceElement from '../cityGuides/experience/ExperienceElement';
import AmbassadorDataBox from '../cityGuides/ambassador/AmbassadorDataBox';
import ItemActions from '../ItemActions/ItemActions';
import '../../styles/containers/CityGuide.css';
import CollapsableItem from '../utils/CollapsableItem';

class State {
  guide = undefined;
  fileData = '';
  screen = 'base';
  elementIndex = -1;
  isPublished = false;
  changing = false;
  deleting = false;
  publishing = false;
  drafting = false;
  updatableElement = undefined;
  redy = false;
  backpage = false;
  openModal = false;
  modalContent: () => ReactNode = () => {
    return null;
  };
  modalAction = undefined;
  previousScreen = '';
  fileStatus = '';
  fileName = '';
  isSuccsess = false;
  isError = false;
}

export class CityGuideForm extends React.Component {
  state = new State();

  componentDidMount() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      city,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      entertainments,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      activities,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      ambassadors,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      history,
    } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (history.length > 2) {
      this.setState({ backpage: true });
    }
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    let { guide } = this.props;
    guide = {
      ...guide,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      picture: { isNew: false, data: guide.picture },
      city,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      photos: guide.photos.map(photo => ({
        ...photo,
        isNew: false,
        data: photo.picture,
      })),
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      entertainments: guide.entertainments.filter(
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        ent => entertainments.map(elem => elem.id).indexOf(ent) !== -1
      ),
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      activities: guide.activities // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        .map(elem => activities.find(activity => activity.id === elem))
        .filter(activity => activity),
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      cheatsheet: guide.cheatsheet.map(cheatsheet => ({
        ...cheatsheet,
        picture: { isNew: false, data: cheatsheet.picture },
      })),
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      ambassador: ambassadors.find(
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        ambassador => ambassador.id === guide.ambassador
      ),
    };
    this.setState({
      guide,
      entertainments,
      activities,
      ambassadors,
      city,
      redy: true,
    });
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  handleChange = ({ target }) => {
    this.setState(prevState => {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      let guide = { ...prevState.guide };
      guide = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.guide,
        [target.id]: target.value,
      };
      return { guide, changing: true };
    });
  };

  back = ({ currentTarget }) => {
    const previousScreen = currentTarget.getAttribute('data-screen');
    this.setState({ screen: 'base', previousScreen });
  };

  toElementManagement = (elementIndex, receiver) => {
    const { guide } = this.state;
    const id = parseInt(elementIndex, 10);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const updatableElement = id > -1 ? guide[receiver][id] : undefined;
    this.setState({
      modalContent: this[receiver],
      openModal: true,
      modalAction: undefined,
      elementIndex: id,
      updatableElement,
    });
  };

  elementSubmit = (element, addElse, receiver) => {
    const { elementIndex, guide } = this.state;
    if (elementIndex === -1) {
      this.changeGuideState({
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        [receiver]: [...guide[receiver], element],
      });
      if (addElse) {
        this.changeState({ elementIndex: -1 });
        return;
      }
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      guide[receiver][elementIndex] = element;
      this.changeGuideState({
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        [receiver]: [...guide[receiver]],
      });
    }
    this.changeState({ openModal: false, elementIndex: -1 });
  };

  deleteElement = (index, receiver) => {
    const { guide } = this.state;
    const id = parseInt(index, 10);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    guide[receiver][id] = undefined;
    this.changeGuideState({
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      [receiver]: Array.isArray(guide[receiver])
        ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          guide[receiver].filter(elem => elem)
        : undefined,
    });
  };

  addEntertainment = async (value, act) => {
    const { guide } = this.state;
    switch (act.action) {
      case 'select-option': {
        this.changeGuideState({
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          entertainments: [...guide.entertainments, value.value.id],
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  deletePhoto = id => {
    const { guide } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const newArray = guide.photos.filter(elem => elem.id !== id);
    this.changeGuideState({
      photos: newArray,
    });
  };

  onFileChange = async event => {
    const { target, currentTarget } = event;
    if (target.files.length === 0) {
      return;
    }
    const type = currentTarget.getAttribute('data-type');
    if (
      target.files[0].type !== 'image/png' &&
      target.files[0].type !== 'image/jpeg'
    ) {
      this.setState({
        isError: true,
        errorText: 'You can upload only png or jpg files',
      });
      setTimeout(this.hideMessage, 5 * 1000);
      return;
    }
    if (type === 'general') {
      this.changeGuideState({
        picture: {
          isNew: true,
          blob: target.files[0],
          data: await getBase64(target.files[0]),
        },
      });
      return;
    }
    const { guide } = this.state;
    const tasks = Array.from(target.files).map(async file => {
      const data = await getBase64(file);
      return { isNew: true, blob: file, data };
    });
    const newData = await Promise.all(tasks);
    this.changeGuideState({
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      photos: [...guide.photos, ...newData],
    });
  };

  closeModal = () => {
    this.setState({ openModal: false, deleting: false });
  };

  toDelete = () => {
    this.setState({
      openModal: true,
      modalContent: this.renderDeleteContent,
      modalAction: this.deleteGuide,
      ActionButtonText: 'Delete',
      deleting: true,
    });
  };

  deleteGuide = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions, toCityPage } = this.props;
    const { guide } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    actions.delete(guide.id);
    toCityPage();
  };

  getAvaliableEntertainments = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { guide, entertainments } = this.state;
    const newEntertainments = entertainments
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      .filter(ent => guide.entertainments.indexOf(ent.id) === -1)
      .map(entertainment => ({
        value: entertainment,
        label: entertainment.title,
        icon: entertainment.picture,
      }));
    return newEntertainments;
  };

  getAvaliableActivities = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { guide, activities } = this.state;
    const newActivities = activities
      .filter(
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        act => guide.activities.map(elem => elem.id).indexOf(act.id) === -1
      )
      .map(activity => ({
        value: activity,
        label: activity.title,
        icon: getActivityPhoto(activity),
      }));
    return newActivities;
  };

  changePublishedStatus = () => {
    this.setState({ isPublished: false, changing: true });
  };

  getActivities = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activities } = this.state;
    return activities.map(activity => ({
      value: activity,
      label: activity.title,
      icon: getActivityPhoto(activity),
    }));
  };

  addExperience = (value, act) => {
    const { guide } = this.state;
    switch (act.action) {
      case 'select-option': {
        this.changeGuideState({
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          activities: [...guide.activities, value.value],
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  addAmbassador = selectedAmbassador => {
    this.changeGuideState({
      ambassador: selectedAmbassador.value,
    });
  };

  hideMessage = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isError: false });
    }
  };

  changeState = data => {
    this.setState(prevState => {
      const newState = {
        ...prevState,
        ...data,
      };
      return newState;
    });
  };

  toCityManagement = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.goBack();
  };

  changeGuideState = data => {
    this.setState(prevState => {
      const newState = {
        ...prevState,
        guide: {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.guide,
          ...data,
        },
        changing: true,
      };
      return newState;
    });
  };

  uploadImage = async (image, id, type) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    if (image.isNew) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      const urlData = await actions.getUrlForImage(type, id);
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      actions.uploadImage(urlData.url, image.blob);
      return urlData.id;
    }
    return id;
  };

  handleSubmit = async guide => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    let photos = guide.photos.map(async photo => ({
      id: await this.uploadImage(photo, photo.id, 'photos'),
      picture: undefined,
    }));
    photos = await Promise.all(photos);
    let cheatsheet = guide.cheatsheet.map(async cheat => ({
      ...cheat,
      id: await this.uploadImage(cheat.picture, cheat.id, 'cheatsheet'),
      picture: undefined,
    }));
    cheatsheet = await Promise.all(cheatsheet);
    const sendingGuide = {
      ...guide,
      id: await this.uploadImage(guide.picture, guide.id, 'guides'),
      title: guide.title.trim(),
      text: guide.text.trim(),
      popularity: guide.popularity.trim(),
      dyk: guide.dyk.trim(),
      picture: undefined,
      photos,
      cheatsheet,
      activities: guide.activities.map(activity => activity.id),
      ambassador: guide?.ambassador?.id,
    };
    if (!sendingGuide.id) delete sendingGuide.id;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const newGuide = await actions.update(sendingGuide);
    this.changeState({
      publishing: false,
      drafting: false,
      isPublished: true,
      guide: {
        ...guide,
        id: newGuide.id,
        picture: { ...guide.picture, isNew: false },
      },
      changing: false,
    });
    setTimeout(this.changePublishedStatus, 5000);
  };

  publishGuide = async () => {
    const { guide } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    guide.published = true;
    this.setState({ publishing: true });
    await this.handleSubmit(guide);
  };

  publishAsDraft = async () => {
    const { guide } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    guide.published = false;
    this.setState({ drafting: true });
    await this.handleSubmit(guide);
  };

  cheatsheet = () => {
    const { updatableElement } = this.state;
    return (
      <CheatsheetForm
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        back={this.back}
        onSubmit={this.elementSubmit}
        cheatsheet={updatableElement}
      />
    );
  };

  happenings = () => {
    const { updatableElement } = this.state;
    return (
      <CityHappeningForm
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        back={this.back}
        type='happenings'
        onSubmit={this.elementSubmit}
        cityHappening={updatableElement}
      />
    );
  };

  articles = () => {
    const { updatableElement } = this.state;
    return (
      <CityHappeningForm
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        back={this.back}
        type='articles'
        getActivities={this.getActivities}
        onSubmit={this.elementSubmit}
        cityHappening={updatableElement}
      />
    );
  };

  renderDeleteContent = () => (
    <div style={{ marginBottom: '40px' }}>
      Are you sure you want to delete this guide?
    </div>
  );

  render() {
    const {
      guide,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      entertainments,
      redy,
      publishing,
      drafting,
      deleting,
      changing,
      isPublished,
      openModal,
      backpage,
      modalContent,
      modalAction,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      ActionButtonText,
      fileStatus,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      ambassadors,
    } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { city, cityGuideActions } = this.props;
    const entertainmentsActions = {
      deleteEntertainment: this.deleteElement,
    };
    const cheatsheetsActions = {
      deleteCheatsheet: this.deleteElement,
      updateCheatsheet: this.toElementManagement,
    };
    const photosActions = {
      deletePhoto: this.deletePhoto,
    };
    const experiencesActions = {
      deleteExperience: this.deleteElement,
    };
    const cityHappeningsActions = {
      deleteCityHappenings: this.deleteElement,
      updateCityHappenings: this.toElementManagement,
    };
    const placesActions = {
      deletePlace: this.deleteElement,
      updatePlace: this.toElementManagement,
    };

    const ambassadorActions = {
      deleteExperience: this.deleteElement,
    };

    if (!redy) {
      return <Spinner />;
    }

    const isMobile = isMobileResolution();
    const isExpanded = !isMobile;
    // @ts-ignore
    // @ts-ignore
    return (
      <Fragment>
        {isPublished && <Succsess text='Saving complete' />}
        <Modal
          open={openModal}
          closeModal={this.closeModal}
          cancel={this.closeModal}
          action={modalAction}
          actionButtonText={ActionButtonText}
        >
          {modalContent()}
        </Modal>
        <TopPanel isDetailsPage>
          <div
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            type='button'
            className='btn-nav back'
            onClick={backpage ? this.toCityManagement : undefined}
            style={{ marginLeft: '15px' }}
            aria-label='left Align'
          >
            {backpage && (
              <>
                <i
                  className='fas fa-arrow-left'
                  style={{ paddingRight: '8px' }}
                />
                <span className='page-back'>Back</span>
              </>
            )}
            <span className='page-back-mobile'>{city}</span>
          </div>
          <div className='page-actions'>
            <button
              type='button'
              disabled={publishing}
              onClick={this.publishGuide}
              style={{ marginRight: '0px' }}
              className='btn btn-primary pull-right'
            >
              {publishing ? 'Publishing....' : 'Publish Guide'}
            </button>
            <button
              type='button'
              disabled={drafting}
              onClick={this.publishAsDraft}
              className='btn btn-def pull-right'
            >
              {drafting ? 'Saving as Draft....' : 'Save as Draft'}
            </button>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              guide.id && (
                <button
                  type='button'
                  onClick={this.toDelete}
                  className='btn btn-dang pull-right'
                >
                  Delete Guide
                </button>
              )
            }
          </div>
        </TopPanel>
        <div className='data-container'>
          <Form>
            <div className='row' style={{ marginBottom: '25px' }}>
              <div className='col-md-6 col-sm-12 col-xs-12'>
                <div className='data-box'>
                  <div
                    className='media'
                    style={{ marginBottom: '24px', overflow: 'visible' }}
                  >
                    <div className='media-left'>
                      <PhotoWidget
                        header='Photo'
                        onChange={this.onFileChange}
                        full
                        width='120px'
                        height='120px'
                        fileStatus={fileStatus}
                        image={{
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          ...guide.picture,
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          data: guide.picture.data.startsWith(
                            'https://ik.imagekit.io'
                          )
                            ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                              // @ts-ignore
                              `${guide.picture.data}?tr=w-600`
                            : // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                              // @ts-ignore
                              guide.picture.data,
                        }}
                      />
                      <div className='city-status-mobile'>
                        {' '}
                        {
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          guide.published ? 'Published' : 'Draft'
                        }
                      </div>
                    </div>
                    <div
                      className='media-body city-title'
                      style={{ overflow: 'visible' }}
                    >
                      {
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        guide.published !== '' && (
                          <div
                            className='pull-right'
                            style={{
                              fontSize: '20px',
                              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                              // @ts-ignore
                              color: guide.published ? '#23af00' : '#7b7b7b',
                            }}
                          >
                            {
                              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                              // @ts-ignore
                              guide.published ? 'Published' : 'Draft'
                            }
                          </div>
                        )
                      }
                      <h2 className='media-heading'>
                        <b>{city}</b>
                        {
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          guide.city && (
                            <ItemActions actions={cityGuideActions} />
                          )
                        }
                      </h2>
                      <h4 style={{ fontSize: '22px', fontWeight: 'normal' }}>
                        City Guide
                      </h4>
                    </div>
                  </div>
                </div>
                <div className='data-box'>
                  <h4 className='header'>City Info</h4>
                  <CollapsableItem isExpanded={isExpanded}>
                    <GeneraPanel
                      guide={guide}
                      handleChange={this.handleChange}
                      isMobile={isMobile}
                    />
                  </CollapsableItem>
                </div>
                <div className='data-box' style={{ marginBottom: '0' }}>
                  <h4 className='header'>Images</h4>
                  <CollapsableItem isExpanded={isExpanded}>
                    {
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      <FileUploader
                        name='photos'
                        header='photos'
                        full
                        onChange={this.onFileChange}
                        noDragnDrop={isMobile}
                      />
                    }
                    <div className='clearfix' />
                    <div style={{ marginTop: '16px' }}>
                      {
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        guide.photos.length > 0 && (
                          <DragnDropGrid
                            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                            // @ts-ignore
                            content={guide.photos.map(p => ({
                              ...p,
                              data: p.data.startsWith('https://ik.imagekit.it')
                                ? `${p.data}?tr=w-600`
                                : p.data,
                            }))}
                            onChange={this.changeGuideState}
                            actions={photosActions}
                            receiver='photos'
                            Element={PhotoElem}
                          />
                        )
                      }
                    </div>
                  </CollapsableItem>
                </div>
              </div>
              <div className='col-md-6 col-sm-12 col-xs-12'>
                <div className='data-box'>
                  <h4 className='header'>In a Nutshell</h4>
                  <CollapsableItem isExpanded={isExpanded}>
                    <ElementSelector
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      value={null}
                      placeholder='Select Entertainment for Adding'
                      onChange={this.addEntertainment}
                      options={this.getAvaliableEntertainments()}
                    />
                    {
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      guide.entertainments.length > 0 && (
                        <DragnDropTable
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          content={guide.entertainments}
                          entertainments={entertainments.map(e => ({
                            ...e,
                            picture: `${e.picture}?tr=w-600`,
                          }))}
                          onChange={this.changeGuideState}
                          notHeader
                          actions={entertainmentsActions}
                          receiver='entertainments'
                          Element={EntertainmentElement}
                        />
                      )
                    }
                  </CollapsableItem>
                </div>
                <div className='data-box'>
                  <h4 className='header' style={{ paddingLeft: '0px' }}>
                    Cheatsheets
                  </h4>
                  <button
                    type='button'
                    onClick={() =>
                      this.toElementManagement(
                        '-1',
                        'cheatsheet',
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        this.renderCheatsheet
                      )
                    }
                    className='btn btn-def'
                  >
                    + Add New
                  </button>
                  <div className='clearfix' />
                  {
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    guide.cheatsheet.length > 0 && (
                      <CollapsableItem isExpanded={isExpanded}>
                        <DragnDropTable
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          content={guide.cheatsheet.map(ch => ({
                            ...ch,
                            picture: {
                              ...ch.picture,
                              data: `${ch.picture.data}?tr=w-600`,
                            },
                          }))}
                          onChange={this.changeGuideState}
                          notHeader
                          actions={cheatsheetsActions}
                          receiver='cheatsheet'
                          Element={CheatsheetElement}
                        />
                      </CollapsableItem>
                    )
                  }
                </div>
                <div className='data-box'>
                  <h4 className='header' style={{ paddingLeft: '0px' }}>
                    City Happenings
                  </h4>
                  <button
                    type='button'
                    onClick={() =>
                      this.toElementManagement(
                        '-1',
                        'happenings',
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        this.renderHappenings
                      )
                    }
                    className='btn btn-def'
                    style={{ marginRight: '0px' }}
                  >
                    + Add New
                  </button>
                  <div className='clearfix' />
                  {
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    guide.happenings.length > 0 && (
                      <CollapsableItem isExpanded={isExpanded}>
                        <DragnDropTable
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          content={guide.happenings}
                          onChange={this.changeGuideState}
                          headers={[
                            'Title',
                            'Subtitle',
                            'Description',
                            'Actions',
                          ]}
                          notHeader={isMobile}
                          actions={cityHappeningsActions}
                          receiver='happenings'
                          Element={CityHappeningsElement}
                        />
                      </CollapsableItem>
                    )
                  }
                </div>
                <div className='data-box'>
                  <h4 className='header' style={{ paddingLeft: '0px' }}>
                    Sleep, Bars, etc
                  </h4>
                  <button
                    type='button'
                    onClick={() =>
                      this.toElementManagement(
                        '-1',
                        'articles',
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        this.renderArticles
                      )
                    }
                    className='btn btn-def'
                    style={{ marginRight: '0px' }}
                  >
                    + Add New
                  </button>
                  <div className='clearfix' />
                  {
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    guide.articles.length > 0 && (
                      <CollapsableItem isExpanded={isExpanded}>
                        <DragnDropTable
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          content={guide.articles}
                          onChange={this.changeGuideState}
                          headers={['Title', 'Actions']}
                          actions={placesActions}
                          receiver='articles'
                          Element={PlacesElement}
                        />
                      </CollapsableItem>
                    )
                  }
                </div>
                <div className='data-box'>
                  <h4 className='header'>Top BACH Experiences</h4>
                  <CollapsableItem isExpanded={isExpanded}>
                    <ElementSelector
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      value={null}
                      placeholder='Select Activity for Adding'
                      onChange={this.addExperience}
                      options={this.getAvaliableActivities()}
                    />
                    <div className='clearfix' />
                    {
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      guide.activities.length > 0 && (
                        <DragnDropTable
                          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                          // @ts-ignore
                          content={guide.activities.map(activity => {
                            const pictures = activity.pictures.map(p => ({
                              ...p,
                              url: `${p.url}?tr=w-600`,
                            }));
                            return { ...activity, pictures };
                          })}
                          onChange={this.changeGuideState}
                          notHeader
                          actions={experiencesActions}
                          receiver='activities'
                          Element={ExperienceElement}
                        />
                      )
                    }
                  </CollapsableItem>
                </div>
                <AmbassadorDataBox
                  guide={guide}
                  ambassadors={ambassadors}
                  addAmbassador={this.addAmbassador}
                  changeGuideState={this.changeGuideState}
                  ambassadorActions={ambassadorActions}
                  isExpanded={isExpanded}
                />
              </div>
              <RouterLeavingGuard
                when={changing}
                shouldBlockNavigation={() => !deleting && changing}
              />
            </div>
          </Form>
          <div className='page-actions-mobile' style={{ padding: '20px 10px' }}>
            <button
              type='button'
              disabled={publishing}
              onClick={this.publishGuide}
              className='btn btn-primary pull-right'
            >
              {publishing ? 'Publishing....' : 'Publish Guide'}
            </button>
            <button
              type='button'
              disabled={drafting}
              onClick={this.publishAsDraft}
              className='btn btn-def pull-right'
            >
              {drafting ? 'Saving as Draft....' : 'Save as Draft'}
            </button>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              guide.id && (
                <button
                  type='button'
                  onClick={this.toDelete}
                  className='btn btn-dang pull-right'
                >
                  Delete Guide
                </button>
              )
            }
          </div>
        </div>
      </Fragment>
    );
  }
}
